/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'file-percent': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M14 2l6 6v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2h8M7.37 20L15 12.35 13.65 11 6 18.65 7.37 20M13 9h5.5L13 3.5V9m-5.5 2A1.5 1.5 0 006 12.5 1.5 1.5 0 007.5 14 1.5 1.5 0 009 12.5 1.5 1.5 0 007.5 11m6 6a1.5 1.5 0 00-1.5 1.5 1.5 1.5 0 001.5 1.5 1.5 1.5 0 001.5-1.5 1.5 1.5 0 00-1.5-1.5z"/>'
  }
})
